import { connect } from 'react-redux';

import eventsActionCreators from '_store/_actions/events';

import Events from './Events';

const mapStateToProps = (state) => ({
  events: state.events.events,
  isLoading: state.events.isLoading,
  user: state.auth.user,
});

const mapDispatchToProps = {
  onFetchEvents: eventsActionCreators.fetchEvents,
  onCreateEvent: eventsActionCreators.createEvent,
  onUpdateEvent: eventsActionCreators.updateEvent,
  onDeleteEvent: eventsActionCreators.deleteEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);
